module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="prefs-commute-address">\n    <p>From</p>\n    <div class="prefs-commute-address-container">\n        <div class="prefs-commute-address-input fs-hide">\n            <input type="text"\n                   placeholder="Enter address..."\n                   autocomplete="street-address"\n                   autocorrect="off"\n            />\n            <div class="form-error" style="display: none"></div>\n            <div class="prefs-commute-address-dym-container" style="display: none">\n                <strong>Did you mean</strong>\n                <a href="#" class="prefs-commute-address-dym"></a>\n            </div>\n        </div>\n    </div>\n    ';
 if (showSaveLink) { ;
__p += '\n        <a href="javascript://" class="btn btn-secondary js-save-address">Save</a>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}